import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=774a3e02&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=774a3e02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774a3e02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774a3e02')) {
      api.createRecord('774a3e02', component.options)
    } else {
      api.reload('774a3e02', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=774a3e02&scoped=true", function () {
      api.rerender('774a3e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/funConfig/detail.vue"
export default component.exports